:host {
  display: block;
}

uiaas-search-mobile-filters {
  &.expand-width {
    margin-left: -31px;
    margin-right: -31px;
    width: calc(100% + 62px);
    margin-bottom: 20px;
  }
}
